module.exports = __webpack_public_path__ + "static/media/img_process3.0c961e01.png";